import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Separator from 'flarum/common/components/Separator';
import PostMeta from 'flarum/forum/components/PostMeta';
import * as PostControls from 'flarum/forum/utils/PostControls';
import { ShareDropdownButton, ShareIconButton, ShareLinkButton, doesSupportWebShare, shareUrl } from '../common';
app.initializers.add('davwheat/flarum-ext-share', () => {
  if (!doesSupportWebShare()) return;
  const displayType = () => app.forum.attribute('davwheat-share.share_button_style');
  extend(CommentPost.prototype, 'actionItems', function (items) {
    const type = displayType();
    if (type === 'menu') return;
    const ShareButton = type === 'text' ? ShareLinkButton : ShareIconButton;
    const post = this.attrs.post;
    const discussion = post.discussion();
    items.add('davwheat-share', m(ShareButton, {
      url: PostMeta.prototype.getPermalink(post),
      discussionTitle: discussion.title()
    }), 10);
  });
  extend(PostControls, 'controls', function (items, post) {
    const type = displayType();
    if (type !== 'menu') return;
    const discussion = post.discussion();
    items.add('davwheat-share', m(ShareDropdownButton, {
      url: PostMeta.prototype.getPermalink(post),
      discussionTitle: discussion.title()
    }), 999);
    items.add('davwheat-share-Separator', Separator.component(), 998);
  });
});
export { ShareDropdownButton, ShareIconButton, ShareLinkButton, doesSupportWebShare, shareUrl };